import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';

import { FixedFullBleedPage } from '@/components/fixed-routes/fixed-full-bleed-page';
import { CONFIGURATOR_BASE } from './store/configurator';
import ConfiguratorRoot from './index';
import ThemeStep from './steps/theme';
import ColorsStep from './steps/colors';
import ReviewStep from './steps/review';
import PaymentStep from './steps/payment';

/**
 * Full-bleed route tree for the configurator-v0 wizard — the SHORT flow (Theme →
 * Colors & Art Style → Payment review → Payment). Which flow a new owner lands on is
 * chosen from the `startProperties` hand-off; see `src/utils/configurator-flow.ts`.
 *
 * Like v3 this is a standalone full-bleed wizard (own chrome), wrapped in
 * `FixedFullBleedPage` (auth gate only, no chrome).
 *
 * It is a LAYOUT route: `ConfiguratorRoot` provides the shared `ConfiguratorProvider` +
 * page shell and renders the active step via `<Outlet/>`, so wizard state persists across
 * step navigation.
 */
export const configuratorV0Route: RouteObject = {
  path: CONFIGURATOR_BASE,
  element: (
    <FixedFullBleedPage>
      <ConfiguratorRoot />
    </FixedFullBleedPage>
  ),
  children: [
    { index: true, element: <Navigate to="theme" replace /> },
    { path: 'theme', element: <ThemeStep /> },
    { path: 'colors', element: <ColorsStep /> },
    { path: 'review', element: <ReviewStep /> },
    { path: 'payment', element: <PaymentStep /> },
    { path: '*', element: <Navigate to="theme" replace /> },
  ],
};

export default configuratorV0Route;
